import BasicFields from 'routes/ReferralForm/BasicFields/BasicFields';

export default BasicFields;
